import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'reactstrap'
import FileSaver from 'file-saver'

import api from '../api'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default class DownloadResult extends Component {
    downloadResult = async e => {
        e.preventDefault()
        const { resultFileId, subject } = this.props

        const res = await api.downloadResult(subject, resultFileId)
        if (res && res.data) {
            FileSaver.saveAs(res.data, `${subject}.xlsx`)
            this.props.onSuccess({
                title: 'Gelukt',
                message: `Bestand ${subject}.xlsx succesvol gedownload.`
            })
        } else {
            this.props.onError({
                title: 'Fout tijdens downloaden',
                message: `Er is een fout opgetreden tijdens het downloaden van ${subject}.xlsx`
            })
        }
    }

    render() {
        return (
            <React.Fragment>
                <Button className="ao-importdetail__action btn btn-outline-primary" onClick={ this.downloadResult }>
                    <FontAwesomeIcon icon="download">Download resultaat</FontAwesomeIcon>
                </Button>
            </React.Fragment>
        )
    }
}

DownloadResult.propTypes = {
    resultFileId: PropTypes.string,
    subject: PropTypes.string,
    onError: PropTypes.func,
    onSuccess: PropTypes.func
}
